<template>
	<div class="login-wrap">
		<div class="ms-login">
			<div class="ms-title">会员注册</div>
			<el-form :model="login" :rules="rules" ref="login" label-width="80px" class="ms-content" v-loading="loading"
				element-loading-text="注册中..." element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)">
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="login.Name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="Sex">
					<el-select v-model="login.Sex" placeholder="请选择性别">
						<el-option label="男" value="1"></el-option>
						<el-option label="女" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年龄" prop="Age">
					<el-input v-model="login.Age" placeholder="请输入年龄" maxlength='2'></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="CompanyName">
					<el-input v-model="login.CompanyName" placeholder="请输入单位"></el-input>
				</el-form-item>
				<el-form-item label="单位地址" prop="CompanyAddress">
					<el-input v-model="login.CompanyAddress" placeholder="请输入单位地址"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="IdentityCard">
					<el-input v-model="login.IdentityCard" placeholder="请输入身份证号"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="Phone">
					<el-input v-model="login.Phone" maxlength='11' placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model="login.password" type="password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="login-btn">
						<el-button type="primary" @click="submitForm('login')">注 册</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				login: {
					Name: "",
					Sex: "",
					Age: "",
					CompanyName: "",
					CompanyAddress: "",
					IdentityCard: "",
					Phone: "",
					password: ""
				},
				rules: {
					// 要以数组形式展示
					Name: [{
							required: true,
							message: "用户名不能为空",
							trigger: "change"
						},
						{
							min: 2,
							max: 30,
							message: "长度在 2 到 30 个字符",
							trigger: "blur"
						}
					],
					Sex: [{
						required: true,
						message: "请选择性别",
						trigger: "change"
					}],
					Age: [{
							required: true,
							message: "年龄不能为空",
							trigger: "blur"
						},
						{
							pattern: /^[0-9]*$/,
							message: "只支持数字",
							trigger: "blur"
						}
					],
					CompanyName: [{
							required: true,
							message: "单位不能为空",
							trigger: "blur"
						},
						{
							min: 1,
							max: 30,
							message: "长度在 1 到 30 个字符",
							trigger: "blur"
						}
					],
					IdentityCard: [{
							required: true,
							message: "身份证号不能为空",
							trigger: "blur"
						},
						{
							pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
							message: "目前只支持中国大陆的身份证号",
							trigger: "blur"
						},
						{
							required: true,
							validator: this.bargainIdentityCard,
							trigger: "blur"
						}
					],
					Phone: [{
							required: true,
							message: "手机号不能为空",
							trigger: "blur"
						},
						{
							min: 6,
							max: 11,
							message: "长度在 6 到 11 个字符",
							trigger: "blur"
						},
						{
							pattern: /^1[0123456789]\d{9}$/,
							message: '目前只支持中国大陆的手机号码',
							trigger: "blur"
						},
						{
							required: true,
							validator: this.bargainMoney,
							trigger: "blur"
						}
					],
					CompanyAddress: [{
							required: true,
							message: "单位地址不能为空",
							trigger: "blur"
						},
						{
							min: 6,
							max: 30,
							message: "长度在 6 到 30 个字符",
							trigger: "blur"
						}
					],
					password: [{
							required: true,
							message: "密码不能为空",
							trigger: "blur"
						},
						{
							min: 6,
							max: 12,
							message: "长度在 6 到 12 个字符",
							trigger: "blur"
						}
					]
				},
				RoleId: "705d2a4d-d53b-4182-aad5-2b4cb6c5e2eb", // 供应商角色id
				loading: false
			};
		},
		created() {
			this.$store.commit("clearTags");
			console.log(this.$route)
		},
		methods: {
			bargainMoney(rule, value, callback) {
				var token = this.token;
				axios({
					method: 'POST',
					url: this.$store.state.pcurl+"CheckPhone?Phone=" + value,
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					if (res.status == 200) {
						if (res.data.Data) {
							callback()
						} else {
							callback(new Error("该手机号已被注册"))
						}
					} else {
						callback(new Error("获取手机号信息失败"))
					}
				})
			},
			bargainIdentityCard(rule, value, callback) {
				var token = this.token;
				axios({
					method: 'POST',
					url: this.$store.state.pcurl+"CheckIdentityCard?IdentityCard=" + value,
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					if (res.status == 200) {
						if (res.data.Data) {
							callback()
						} else {
							callback(new Error("该身份证号已被注册"))
						}
					} else {
						callback(new Error("获取身份证号信息失败"))
					}
				})
			},
			submitForm(login) {
				this.$refs[login].validate(valid => {
					if (valid) {
						this.loading = true;
						this.login.State = 1;
						this.login.RoleId = this.RoleId;
						axios({
							method: 'POST',
							url: this.$store.state.pcurl+'AddUser',
							data: this.login,
						}).then((res) => {
							if (res.data.Status == 200) {
								this.loading = false;
								this.$message.success('注册成功');
								this.$router.push("/Login");
							} else {
								this.$message.error('注册失败');
							}
						}).catch(() => {
							this.$message.error('注册失败');
						})
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			getData() {
				this.$message.success("注册成功");
				this.$router.push("/");
			}
		}
	};
</script>

<style scoped>
	.login-wrap {
		position: relative;
		width: 100%;
		height: 100%;
		/* background-image: url(../assets/img/img1.jpg) no-repeat; */
		background-color:   #006587;
	}

	.ms-title {
		width: 100%;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		color: #000;
		border-bottom: 1px solid #ddd;
	}

	.ms-login {
		position: absolute;
		left: 50%;
		top: 35%;
		width: 500px;
		margin: -190px 0 0 -250px;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.5);
		overflow: hidden;
	}

	.ms-content {
		/* padding: 30px 30px; */
		padding: 30px 50px 0 10px;
	}

	.login-btn {
		text-align: center;
	}

	.login-btn button {
		width: 100%;
		height: 36px;
		margin-bottom: 10px;
	}

	.login-tips {
		font-size: 12px;
		line-height: 30px;
		color: #fff;
	}
</style>
